import type { BrandAuthConfig, BrandConnectionIds } from "@brand-auth/types";

/**
 * Global Kinde wiring shared across all applications. Connection IDs and the
 * OTP client ID are account-level constants; per-app settings (kindeDomain,
 * kindeOrgCode, appOrigin) come from D1 at runtime via the `/api/init`
 * response.
 */

/** Production Kinde connection IDs. Tenant-shared across all applications. */
export const GLOBAL_CONNECTION_IDS: BrandConnectionIds = {
  emailPasswordless: "conn_018f086c2c8b8d0865256c986b6ad99f",
  google: "conn_018f086c2c8baa468270ad4c10985209",
  apple: "conn_018f086c2c8ba82b4cf2be4fd309c16f",
  x: "conn_018f086c2c8b9c263c1cb47d623dc1fd",
  discord: "conn_018f086c2c8beb127e6f1be08efbd7ac",
};

/** Kinde Application client ID for OTP-based auth. Global across all apps. */
export const GLOBAL_KINDE_CLIENT_ID = "9efef26ed4d44115b5877d1a2a729f56";

/**
 * Build a {@link BrandAuthConfig} from per-app values (sourced from D1) merged
 * with the global client ID and connection IDs. Per-app settings come from the
 * `/api/init` response at runtime.
 *
 * When `kindeClientId` is provided, it overrides the global default — this
 * allows dev/staging applications to use a separate Kinde application.
 */
export const buildAuthConfig = (app: {
  kindeDomain: string;
  kindeOrgCode: string;
  appOrigin: string;
  kindeClientId?: string;
}): BrandAuthConfig => ({
  appOrigin: app.appOrigin,
  kindeDomain: app.kindeDomain,
  kindeClientId: app.kindeClientId ?? GLOBAL_KINDE_CLIENT_ID,
  kindeOrgCode: app.kindeOrgCode,
  connectionIds: GLOBAL_CONNECTION_IDS,
});
